// @flow
import { Component } from 'react';
import PropTypes from 'prop-types';
import TypeaheadProvider from 'app/common/lib/TypeaheadProvider';

type Props = {|
  children?: any,
  onTypeaheadSuggestionsChange: (suggestions: Array<Object>, query: string) => void,
  resourceName: string,
  resourceOptions?: Object,
  allowSearchOnMount?: boolean,
  value: string,
|};

export default class Typeahead extends Component<Props> {
  static propTypes = {
    children: PropTypes.node,
    onTypeaheadSuggestionsChange: PropTypes.func.isRequired,
    resourceName: PropTypes.string.isRequired,
    resourceOptions: PropTypes.shape({}),
    allowSearchOnMount: PropTypes.bool,
    value: PropTypes.string.isRequired,
  };

  static defaultProps = {
    resourceName: 'TypeaheadResource',
  };

  componentDidMount() {
    const resourceOptions = this.props.resourceOptions || {};
    this.provider = new TypeaheadProvider({
      resource_name: this.props.resourceName,
      ...resourceOptions,
    });
    const { value } = this.props;
    if (value !== undefined && value !== null && this.props.allowSearchOnMount) {
      this.search(this.props.value);
    }
  }

  UNSAFE_componentWillReceiveProps({ value }: Props) {
    if (value !== undefined && value !== null && value !== this.props.value) {
      this.search(value);
    }
  }

  provider: any;
  searchCache: { [query: string]: Array<Object> } = (Object.create(null): any);
  lastSearchedQuery = null;

  search = (query: string) => {
    this.lastSearchedQuery = query;
    if (query in this.searchCache) {
      this.props.onTypeaheadSuggestionsChange(this.searchCache[query], query);
    } else {
      this.provider.search(query, ({ items }) => {
        this.searchCache[query] = items;
        if (query === this.lastSearchedQuery) {
          this.props.onTypeaheadSuggestionsChange(items, query);
        }
      });
    }
  };

  render() {
    return this.props.children || null;
  }
}
